module.exports = __webpack_public_path__ + "img/IMG_7841.582b4006.jpg";